import axios from './axios';
import { CREATE_TEMP_TRANSACTION, GET_TRANSACTION } from './APILinks';

export const createTempTransaction = (amount) =>
  axios.post(CREATE_TEMP_TRANSACTION, {
    amount,
  });

export const apiGetTransaction = (params) =>
  axios.get(GET_TRANSACTION, {
    params,
  });
